var map = {
	"./10.png": 1289,
	"./AboutUs.png": 1693,
	"./CDN.svg": 1694,
	"./Colocation.svg": 1695,
	"./about-header.svg": 1696,
	"./analytics.svg": 1697,
	"./budget.svg": 1698,
	"./consulting.svg": 1699,
	"./container.svg": 1700,
	"./contract.svg": 1701,
	"./cost.svg": 1702,
	"./demo.svg": 1703,
	"./header.svg": 1704,
	"./history.png": 1705,
	"./license.svg": 1706,
	"./mission.png": 1707,
	"./missionicon.png": 1708,
	"./pop.svg": 1709,
	"./sazman.svg": 1710,
	"./security.svg": 1711,
	"./uptime.svg": 1712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2719;